// @flow
export const SCROLLBAR_THEME_API = {
  root: '',
};
